import { z } from 'zod';

import { WorkoutPlanId } from '../../BrandedIds';
import { zodBrandedUuid } from '../../utils';
import { BaseLoanEvent } from '../BaseLoanEvent';

/*
 Workout plans that were mistakenly added and should not be reported
*/
export const ArchiveWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('archiveWorkoutPlan'),
  workoutPlanId: zodBrandedUuid<WorkoutPlanId>(),
});
export type ArchiveWorkoutPlanEvent = z.infer<typeof ArchiveWorkoutPlanEvent>;
